var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4 h-full flex items-center"},[_c('h1',{staticClass:"mt-2 text-2xl text-blue-800 font-bold"},[_vm._v(_vm._s(_vm.pageHeader))])])}
var staticRenderFns = []

export { render, staticRenderFns }